import styles from './SmileTitle.module.css';

interface SmileTitleProps {
    text: string;
}

export function SmileTitle({ text }: SmileTitleProps) {
    return (
        <div className={styles.title}>
            {text}
        </div>
    );
}
